<template>
  <router-view />
</template>

<script>
export default {
  name: "productionassistant",
};
</script>

